import { requestGet } from '@/common/request';

export interface channelTypeParams {}

export interface channelTypeRes {
  ret: string;
  msg: string;
  data: {
    list: TypeList[];
  };
}

export interface TypeList {
  type: number;
  desc: string;
}

export async function channelType(params?: channelTypeParams): Promise<channelTypeRes> {
  return await requestGet('/channelActivity/channelType', params);
}
